export const localeFormat = {
  EN_US: 'en-US'
};
